export default {
  fontSize: {
    xsmall: 10,
    small: 13,
    medium: 14,
    base: 15,
    root: 16,
    large: 18,
    xlarge: 36,
    xxlarge: 48
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 600,
    bolder: 700,
    boldest: 800
  }
};
